import Treaser from './treaser';
import { useGlobal } from '@/utils/useGlobal';

export default function GlacierWaveH5({ stage }: any) {
    const { useEffect, useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    useEffect(() => {
        if (locale === 'kr' && stage !== 1) {
            router.push('/404');
        }
    }, []);
    return (
        <>
            <Treaser curStage={stage} />
        </>
    );
}
